export { EnergyDetails } from './energy-details.page';
